import { PostStatusPropertyValue } from 'api/clients/PropertyClient'
import { Selection } from '@react-types/shared'
import { Menu } from 'components/Menu/Menu'
import { SelectableItem } from 'components/Menu/MenuItem'
import Styles from './FiltersMenu.module.scss'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Text } from 'blaze-ui/Text/Text'
import { ArrowLeft } from 'blaze-ui/icons'
import { Tag } from 'common/OptionSelect/Tag'

type StatusSelectProps = {
  selectedKeys?: string[] | 'all' | undefined
  onChange: (statusKeys: 'all' | string[]) => void
  onBack: () => void
}

export const STATUS_COLOR: Record<PostStatusPropertyValue, string> = {
  [PostStatusPropertyValue.Draft]: '#B1BECD',
  [PostStatusPropertyValue.ReminderScheduled]: '#FFEFC5',
  [PostStatusPropertyValue.AutoPostScheduled]: '#FFD74A',
  [PostStatusPropertyValue.Posted]: '#028C3A',
  [PostStatusPropertyValue.Failed]: '#E53535',
}

export const StatusMenu = ({ selectedKeys, onChange, onBack }: StatusSelectProps) => {
  const statusItems = [
    PostStatusPropertyValue.Draft,
    PostStatusPropertyValue.ReminderScheduled,
    PostStatusPropertyValue.AutoPostScheduled,
    PostStatusPropertyValue.Posted,
    PostStatusPropertyValue.Failed,
  ]

  const selectionSet: Selection =
    selectedKeys === 'all' || !selectedKeys || selectedKeys.length === 0 ? 'all' : new Set(selectedKeys)

  const isSelected = selectionSet !== 'all'

  const handleChange = (status: 'all' | string) => {
    if (status === 'all') {
      onChange('all')
      return
    }

    if (selectedKeys && selectedKeys !== 'all') {
      if (selectedKeys.includes(status)) {
        const newSelection = selectedKeys.filter((key) => key !== status)
        onChange(newSelection.length > 0 ? newSelection : 'all')
      } else {
        onChange([...selectedKeys, status])
      }
    } else {
      onChange([status])
    }
  }

  return (
    <>
      <div className={Styles.header}>
        <IconButton icon={ArrowLeft} size="xs" variant="tertiary" onPress={onBack} data-testid="back-button" />
        <Text variant="largeList">Post Status</Text>
      </div>
      <Menu
        selectionMode="multiple"
        selectedKeys={isSelected ? selectionSet : []}
        onAction={(key) => handleChange(key as string)}
        itemClassName={Styles.menuItem}
        showCheckmark
      >
        {statusItems.map((status) => (
          <SelectableItem closeOnSelect={false} type="item" key={status}>
            <Tag size="md" color={STATUS_COLOR[status]}>
              {status}
            </Tag>
          </SelectableItem>
        ))}
      </Menu>
    </>
  )
}
